/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave exactly one field blank to solve for it.`)
};

const es_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja exactamente un campo en blanco para calcularlo.`)
};

const de_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lassen Sie genau ein Feld leer, um es zu berechnen.`)
};

const nl_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laat precies één veld leeg om het te berekenen.`)
};

const fr_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez exactement un champ vide pour le résoudre.`)
};

const it_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia esattamente un campo vuoto per risolverlo.`)
};

const pt_br2_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe exatamente um campo em branco para resolvê-lo.`)
};

const pt_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe exatamente um campo em branco para o calcular.`)
};

const ja_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求めたい項目を1つだけ空欄にしてください。`)
};

const zh_massmol_hint_leave_blank = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`恰好留空一个字段以求解该字段。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const massmol_hint_leave_blank = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.massmol_hint_leave_blank(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("massmol_hint_leave_blank", locale)
	if (locale === "en") return en_massmol_hint_leave_blank(inputs)
	if (locale === "es") return es_massmol_hint_leave_blank(inputs)
	if (locale === "de") return de_massmol_hint_leave_blank(inputs)
	if (locale === "nl") return nl_massmol_hint_leave_blank(inputs)
	if (locale === "fr") return fr_massmol_hint_leave_blank(inputs)
	if (locale === "it") return it_massmol_hint_leave_blank(inputs)
	if (locale === "pt-BR") return pt_br2_massmol_hint_leave_blank(inputs)
	if (locale === "pt") return pt_massmol_hint_leave_blank(inputs)
	if (locale === "ja") return ja_massmol_hint_leave_blank(inputs)
	return zh_massmol_hint_leave_blank(inputs)
};